//This method is used to transform the GraphQL Response into a plain object
export const transformAllRubricModel = model => {
  return {
    id: model._id,
    name: model.name,
    maxPoints: model.maxPoints,
    includedInSum: model.includedInSum,
    campId: model.camp,
    assignedJudge: model.assignedJudge,
    eventName: model.event.name,
    eventStatus: model.event.status,
  };
};
